import { SocketMessage } from '../types/messaging'
import { DeviceUpdate } from '../classes/DeviceCollection'
import { Device, DeviceHwID, Rule } from '../types/models'
import { useState } from 'react'
import { useApp } from './useApp'
import { SystemControl } from '../classes/SystemControl'

/**
 * Helper to gather all ports from all devices and maintaining the latest values for everything.
 *
 * NOTE: This must be called only from main page.
 */
export function useDevices() {
  // TODO: Some prevention to re-initialize would be nice.
  const [, setCounter] = useState(0)
  const app = useApp()

  const refresh = (): void => {
    setCounter((old) => {
      return (old + 1) % 100000000
    })
  }

  SystemControl.setRefresh(refresh)

  const onMessage = (msg: SocketMessage): void => {
    // TODO: This could use some cleanup. Responsibility slipped in multiple places.
    SystemControl.onMessage(msg)
    if (SystemControl.canRefresh(msg)) {
      refresh()
    }
  }

  const setDevices = (devices: Device[]): void => {
    SystemControl.setDevices(devices)
    refresh()
  }

  const onUpdate = (params: DeviceUpdate): void => {
    SystemControl.onUpdate(params)
    refresh()
  }

  const addRule = (hwId: DeviceHwID, rule: Rule): void => {
    SystemControl.addRule(hwId, rule)
    refresh()
  }

  return {
    onMessage,
    onUpdate,
    addRule,
    setDevices,
    control: SystemControl.control(app, refresh)
  }
}
